module.exports = __webpack_public_path__ + "img/largeScreenBgc.d2c4d806.png";